import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'

interface FrontUrgentOrderState extends ListState<any> {
    //orderInfo: createdata,
    //updateOrdeData: UpdateBackAbroadOrderStatu,
}

class FrontUrgentOrderMutations extends ListMutations<any>{

}
class FrontUrgentOrder extends ListModule<FrontUrgentOrderState, any, any>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,
        id: 0,
        reason: '',
        logisitcsNumber:''
    }
    actions = {
        async getAll(context: ActionContext<FrontUrgentOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/FrontUrgentOrder/GetUrgentDataList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async CreateUrgent(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontUrgentOrder/CreateUrgent', payload.data);
        },
    };
    mutations = {
        setCurrentPage(state: FrontUrgentOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: FrontUrgentOrderState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const fonturgent = new FrontUrgentOrder();
export default fonturgent;